export const SELECTED_BOOKED_MEDIA_IDS = 'mediaIds'
export const FILE_CUSTOM_DATE = 'customDate'
